module.exports = __webpack_public_path__ + "img/Effective Negotiator.c23b30be.svg";